<template>
  <div class="access-instructions-config-generation">
    <el-card>
      <template #header>
        <div class="card-header">
          <el-icon><Key /></el-icon>
          <span>获取通行密钥</span>
        </div>
      </template>
      <div class="card-content">
        <p><strong>url</strong> : /fos/client/access_key</p>
        <p><strong>请求方式</strong> : GET</p>
        <p><strong>接口说明</strong> : 根据临时令牌获取通行密钥，该通行密钥用于对文件的操作。</p>

        <p><strong>请求参数</strong> :</p>
        <!-- 使用 el-table 组件替换原有的 table 标签 -->
        <el-table :data="requestParams" border>
          <el-table-column prop="name" label="参数名称"></el-table-column>
          <el-table-column prop="type" label="参数类型"></el-table-column>
          <el-table-column prop="required" label="是否必填"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
        <p><strong>备注</strong> : 建议tmpToken和secretKey保存在用户服务端，<span style="color: red; font-weight: bold;">请勿放在前端直接请求</span>，以免泄露；token加密规则参见<router-link to="/access-instructions/appendix">附录</router-link></p>

        <p><strong>接口返回</strong> :</p>
        <!-- 使用 el-table 组件替换原有的 table 标签 -->
        <el-table :data="responseData" border>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
        <p><strong>备注</strong> : 返回的数据格式为JSON</p>

        <p><strong>参数实例</strong> :</p>
        <pre><code class="plaintext">
tmpToken=tmpToken&amp;secretKey=secretKey&amp;timestamp=TIMESTAMP&amp;token=TOKEN
        </code></pre>

        <p><strong>接口返回实例</strong> :</p>
        <p><strong>正确返回</strong></p>
        <pre><code class="json" ref="correctResponseCode">
{
"status": 100,
"error": null,
"data": {
  "accessKey": "ACK",
  "expire": 7200
}
}
        </code></pre>
        <p><strong>错误返回</strong></p>
        <pre><code class="json" ref="errorResponseCode">
{
"status": 0,
"unixTime": 1541508995344,
"error": "获取凭证异常",
"data": null
}
        </code></pre>
      </div>
      <div class="access-instructions-footer">
        <router-link to="/access-instructions/config-generation" class="next-document-link">
          <el-icon><ArrowLeft /></el-icon> 配置生成
        </router-link>
        <router-link to="/access-instructions/file-upload" class="next-document-link">
          文件上传 <el-icon><ArrowRight /></el-icon>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Key, ArrowRight, ArrowLeft } from '@element-plus/icons-vue';
import '@/styles/common-access-instructions.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/default.css';

// 定义请求参数数据
const requestParams = [
  { name: 'tmpToken', type: 'String', required: '是', description: '临时密钥' },
  { name: 'secretKey', type: 'String', required: '是', description: '临时密码' },
  { name: 'timestamp', type: 'String', required: '是', description: '时间戳' },
  { name: 'token', type: 'String', required: '是', description: '加密字符串' }
];

// 定义接口返回数据
const responseData = [
  { name: 'status', type: 'int', description: '状态码(100 - 成功 0 - 失败)' },
  { name: 'error', type: 'Object', description: '错误信息(成功时为null)' },
  { name: 'data', type: 'Object', description: '返回数据(失败时为null)' }
];

const correctResponseCode = ref(null);
const errorResponseCode = ref(null);

onMounted(() => {
  if (correctResponseCode.value) {
    hljs.highlightElement(correctResponseCode.value);
  }
  if (errorResponseCode.value) {
    hljs.highlightElement(errorResponseCode.value);
  }
});
</script>

<style scoped>
.access-instructions-config-generation {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.card-content p {
  margin-bottom: 10px;
}

.card-content pre {
  background-color: #f4f4f4;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}

.card-content code {
  font-family: 'Courier New', Courier, monospace;
}

.access-instructions-footer {
  display: flex;
  justify-content: space-between;
}

.next-document-link {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>